import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Toaster, toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import bgImage from "assets/img/register_bg_2.png";
import { Eye, EyeOff, RefreshCw, UserPlus } from "lucide-react";

export default function Register() {
  const [step, setStep] = useState(0);
  const [userEmail, setUserEmail] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [captcha, setCaptcha] = useState("");
  const [captchaInput, setCaptchaInput] = useState("");

  const generateCaptcha = () => {
    const chars = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
    let code = "";
    for (let i = 0; i < 6; i++) {
      code += chars[Math.floor(Math.random() * chars.length)];
    }
    setCaptcha(code);
  };

  useEffect(() => {
    generateCaptcha();
  }, []);

  // let roleArray = [
  //     // { id: 0, role: "Select Role" }, { id: 1, role: "Admin" },
  //     { id: 2, role: "Student" }]
  const navigate = useNavigate();
  const [userformData, setUerformData] = useState({
    email: "",
    phone: "",
    role: "Student",
    password: "",
    firstname: "",
    lastname: "",
    admission_no: "",
  });

  function gettemUserFormValues(e) {
    setUerformData({ ...userformData, [e.target.name]: e.target.value });
  }

  async function getSubmitUsrFormData(e) {
    e.preventDefault();
    if (captchaInput !== captcha) {
      toast.error("Invalid Captcha. Please try again.");
      generateCaptcha();
      setCaptchaInput("");
      return;
    }
    try {
      const token = localStorage.getItem('token');
      console.log("Token:", token);
      const apiUrl = "https://api.nvcti.in/tempuser/signup";
      const responseData = await axios.post(apiUrl, {
        email: userformData.email,
        phone: userformData.phone,
        role: "Student",
        password: userformData.password,
        first_name: userformData.firstname,
        last_name: userformData.lastname,
        admission_no: userformData.admission_no
      }, {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      if (responseData.data && responseData.data.success) {
        toast.success(responseData.data.message || "Registration successful!");

        setUserEmail(userformData.email);
        navigate("/auth/verify/otp", {
          state: {
            email: userformData.email,
            source: "registration",
            message: "Please verify your email to complete registration",
            title: "Email Verification",
            successMessage:
              "Email verified successfully! Registration complete.",
            redirectPath: "/auth/login",
          },
        });

        setUerformData({
          email: "",
          phone: "",
          role: "",
          password: "",
          firstname: "",
          lastname: "",
          admission_no: "",
        });
        return { success: true, data: responseData.data };
      } else {
        toast.error(
          responseData.data.message || "Registration failed. Please try again.",
        );
        return { success: false, error: responseData.data.message };
      }
    } catch (error) {
      let errorMessage = "Something went wrong";
      if (error.response) {
        errorMessage =
          error.response.data.message ||
          `Server error: ${error.response.status}`;
      } else if (error.request) {
        errorMessage = "No response from server. Please check your connection.";
      } else {
        errorMessage = error.message || "Request setup error";
      }
      toast.error(errorMessage);
      return { success: false, error: errorMessage };
    }
  }

  const steps = [
    { label: "User Registration", desc: "Enter user details" },
    { label: "Complete", desc: "Registration complete" },
  ];

  const currentStep = steps[step] || {};

  return (
    <>
      <Toaster position="bottom-left" reverseOrder={false} />
      <main className="fixed inset-0 z-50 bg-dark-primary overflow-y-auto w-full h-screen">
        <section className="relative w-full flex items-start justify-center py-12 px-4 sm:px-6 lg:px-8">
          {/* Background Decorative Element */}
          <div className="fixed top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-full pointer-events-none opacity-20 bg-[radial-gradient(circle_at_50%_0%,rgba(59,130,246,0.3)_0%,transparent_70%)]"></div>

          <div className="relative w-full flex flex-col items-center">
            {step !== 1 && (
              <div className="w-full lg:w-4/12 xl:w-1/3">
                <div
                  className="relative flex flex-col min-w-0 break-words w-full mb-6 rounded-xl bg-dark-card border border-dark-tertiary shadow-2xl transition-all duration-300 hover:border-accent-primary/30"
                  style={{
                    minHeight: "auto",
                    backdropFilter: "blur(8px)"
                  }}
                >
                  <div className="flex-auto px-4 lg:px-10 py-10 pt-8">
                    <div className="text-gray-100 text-center mb-8 font-bold text-2xl">
                      {currentStep.label}
                    </div>

                    {step === 0 && (
                      <form onSubmit={getSubmitUsrFormData}>
                        <div className="relative w-full mb-4">
                          <label className="block text-gray-300 text-sm font-bold mb-2">
                            Admission No <span className="text-red-500">*</span>
                          </label>
                          <input
                            name="admission_no"
                            type="text"
                            value={userformData.admission_no}
                            onChange={gettemUserFormValues}
                            className="border border-dark-tertiary px-4 py-3 placeholder-gray-500 text-gray-100 bg-dark-input rounded-lg text-sm shadow focus:outline-none focus:ring-2 focus:ring-accent-primary focus:border-accent-primary w-full ease-linear transition-all duration-150"
                            placeholder="Enter your admission number"
                            required
                          />
                        </div>
                        <div className="relative w-full mb-4">
                          <label className="block text-gray-300 text-sm font-bold mb-2">
                            First Name <span className="text-red-500">*</span>
                          </label>
                          <input
                            name="firstname"
                            type="text"
                            value={userformData.firstname}
                            onChange={gettemUserFormValues}
                            className="border border-dark-tertiary px-4 py-3 placeholder-gray-500 text-gray-100 bg-dark-input rounded-lg text-sm shadow focus:outline-none focus:ring-2 focus:ring-accent-primary focus:border-accent-primary w-full ease-linear transition-all duration-150"
                            placeholder="Enter your first name"
                            required
                          />
                        </div>
                        <div className="relative w-full mb-4">
                          <label className="block text-gray-300 text-sm font-bold mb-2">
                            Last Name <span className="text-red-500">*</span>
                          </label>
                          <input
                            name="lastname"
                            type="text"
                            value={userformData.lastname}
                            onChange={gettemUserFormValues}
                            className="border border-dark-tertiary px-4 py-3 placeholder-gray-500 text-gray-100 bg-dark-input rounded-lg text-sm shadow focus:outline-none focus:ring-2 focus:ring-accent-primary focus:border-accent-primary w-full ease-linear transition-all duration-150"
                            placeholder="Enter your last name"
                            required
                          />
                        </div>
                        <div className="relative w-full mb-4">
                          <label className="block text-gray-300 text-sm font-bold mb-2">
                            Email <span className="text-red-500">*</span>
                          </label>
                          <input
                            name="email"
                            type="email"
                            value={userformData.email}
                            onChange={gettemUserFormValues}
                            className="border border-dark-tertiary px-4 py-3 placeholder-gray-500 text-gray-100 bg-dark-input rounded-lg text-sm shadow focus:outline-none focus:ring-2 focus:ring-accent-primary focus:border-accent-primary w-full ease-linear transition-all duration-150"
                            placeholder="Enter your email"
                            required
                          />
                        </div>
                        <div className="relative w-full mb-4">
                          <label className="block text-gray-300 text-sm font-bold mb-2">
                            Mobile Number <span className="text-red-500">*</span>
                          </label>
                          <input
                            name="phone"
                            type="text"
                            value={userformData.phone}
                            onChange={gettemUserFormValues}
                            maxLength={10}
                            className="border border-dark-tertiary px-4 py-3 placeholder-gray-500 text-gray-100 bg-dark-input rounded-lg text-sm shadow focus:outline-none focus:ring-2 focus:ring-accent-primary focus:border-accent-primary w-full ease-linear transition-all duration-150"
                            placeholder="Enter your mobile number"
                            required
                          />
                        </div>
                        {/* <div className="relative w-full mb-4">
                                                    <label className="block text-blueGray-600 text-sm font-bold mb-2">
                                                        Role
                                                    </label>
                                                    <select
                                                        name="role"
                                                        value={userformData.role}
                                                        onChange={gettemUserFormValues}
                                                        className="border-0 px-4 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded-lg text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                                        required
                                                    >
                                                        <option value="">Select Role</option>
                                                        {roleArray.map((x) => {
                                                            return (
                                                                <option key={x.id} value={x.id}>
                                                                    {x.role}
                                                                </option>
                                                            );
                                                        })}
                                                    </select>
                                                </div> */}
                        <div className="relative w-full mb-6 ">
                          <label className="block text-gray-300 text-sm font-bold mb-2">
                            Password <span className="text-red-500">*</span>
                          </label>
                          <div className="relative flex flex-row items-center w-full">
                            <input
                              name="password"
                              value={userformData.password}
                              type={showPassword ? "text" : "password"}
                              onChange={gettemUserFormValues}
                              className="border border-dark-tertiary px-4 py-3 pr-12 placeholder-gray-500 text-gray-100 bg-dark-input rounded-lg text-sm shadow focus:outline-none focus:ring-2 focus:ring-accent-primary focus:border-accent-primary w-full ease-linear transition-all duration-150"
                              placeholder="Enter your password"
                              minLength={8}
                              required
                            />
                            <button
                              type="button"
                              onClick={() => setShowPassword(!showPassword)}
                              className="absolute right-4 top-0 bottom-0 my-auto z-50 p-2 text-gray-400 hover:text-gray-200 bg-transparent border-0 outline-none focus:outline-none focus:ring-2 focus:ring-gray-400 rounded cursor-pointer flex items-center justify-center"
                              aria-label={
                                showPassword ? "Hide password" : "Show password"
                              }
                            >
                              {showPassword ? (
                                <EyeOff size={20} strokeWidth={2} />
                              ) : (
                                <Eye size={20} strokeWidth={2} />
                              )}
                            </button>
                          </div>
                        </div>

                        <div className="relative w-full mb-6">
                          <label className="block text-gray-300 text-sm font-bold mb-2">
                            Security Verification <span className="text-red-500">*</span>
                          </label>
                          <div className="flex items-center gap-2">
                            <div
                              className="bg-dark-input border border-dark-tertiary px-6 py-3 rounded-lg text-2xl font-black text-accent-primary tracking-[0.4em] italic select-none text-center flex-1 relative overflow-hidden"
                              style={{
                                backgroundImage: `repeating-linear-gradient(45deg, transparent, transparent 10px, rgba(59, 130, 246, 0.05) 10px, rgba(59, 130, 246, 0.05) 20px)`,
                                textDecoration: 'line-through',
                                textDecorationColor: 'rgba(59, 130, 246, 0.2)',
                                textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
                                minHeight: '56px'
                              }}
                            >
                              {captcha}
                            </div>
                            <button
                              type="button"
                              onClick={generateCaptcha}
                              className="bg-dark-input border border-dark-tertiary p-2.5 rounded-lg text-gray-400 hover:text-accent-primary hover:border-accent-primary transition-all duration-200 flex items-center justify-center shrink-0"
                              title="Refresh Captcha"
                              style={{ width: '48px', height: '48px' }}
                            >
                              <RefreshCw size={18} className="hover:rotate-180 transition-transform duration-500" />
                            </button>
                          </div>
                          <div className="mt-4">
                            <input
                              type="text"
                              value={captchaInput}
                              onChange={(e) => setCaptchaInput(e.target.value)}
                              className="border border-dark-tertiary px-4 py-3 placeholder-gray-500 text-gray-100 bg-dark-input rounded-lg text-sm shadow-inner focus:outline-none focus:ring-2 focus:ring-accent-primary/50 focus:border-accent-primary w-full transition-all duration-200"
                              placeholder="Enter the code shown above"
                              required
                            />
                          </div>
                        </div>

                        <div className="text-center mt-10 pb-4">
                          <button
                            type="submit"
                            className="group relative bg-accent-primary text-white active:bg-accent-hover text-lg font-bold uppercase px-8 py-4 rounded-xl shadow-lg hover:shadow-accent-primary/20 hover:-translate-y-0.5 outline-none focus:outline-none w-full transition-all duration-200 flex items-center justify-center gap-3 overflow-hidden"
                          >
                            <span className="absolute inset-0 bg-white/10 opacity-0 group-hover:opacity-100 transition-opacity"></span>
                            <UserPlus size={20} />
                            Create User Account
                          </button>
                        </div>
                      </form>
                    )}
                  </div>
                </div>

                <div className="flex flex-wrap mt-6 relative">
                  <div className="w-1/2">
                  </div>
                  <div className="w-1/2 text-right">
                    <Link
                      to="/auth/login"
                      className="text-gray-400 hover:text-accent-primary font-semibold text-xl transition-colors"
                    >
                      <small>Already have account?</small>
                    </Link>
                  </div>
                </div>
              </div>
            )}

            {step === 1 && (
              <div className="w-full lg:w-4/12 px-8">
                <div
                  className="relative flex flex-col min-w-0 break-words w-full mb-6 rounded-lg bg-white border border-blueGray-400 shadow-2xl shadow-blueGray-500/40"
                  style={{
                    minHeight: "300px",
                    background: "linear-gradient(145deg, #f0f0f0, #cacaca)",
                  }}
                >
                  <div className="flex-auto px-4 lg:px-10 py-10 pt-8 text-center">
                    <div className="text-green-600 text-center mb-6 font-bold text-3xl">
                      ✓ Registration Complete!
                    </div>
                    <p className="text-blueGray-600 text-lg mb-8">
                      Your account has been successfully verified. You can now
                      login to your account.
                    </p>
                    <Link
                      to="/auth/login"
                      className="bg-blueGray-800 text-white active:bg-blueGray-600 text-sm font-bold uppercase px-6 py-3 rounded-lg shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150"
                    >
                      Go to Login
                    </Link>
                  </div>
                </div>
              </div>
            )}
          </div>
        </section>
      </main>
    </>
  );
}
